import { render } from "./HomeGameMenu.vue?vue&type=template&id=78fa1443&scoped=true"
import script from "./HomeGameMenu.vue?vue&type=script&lang=js"
export * from "./HomeGameMenu.vue?vue&type=script&lang=js"

import "./HomeGameMenu.vue?vue&type=style&index=0&id=78fa1443&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78fa1443"]])

export default __exports__